import { render, staticRenderFns } from "./third-party.vue?vue&type=template&id=a2c1e58a&scoped=true&"
import script from "./third-party.vue?vue&type=script&lang=js&"
export * from "./third-party.vue?vue&type=script&lang=js&"
import style0 from "./third-party.vue?vue&type=style&index=0&id=a2c1e58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c1e58a",
  null
  
)

export default component.exports